module.exports = { "default": require("core-js/library/fn/math/imul"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/imul.js
// module id = qajy
// module chunks = 0